import { envConfig } from '../config';
import { HttpHelper, HttpServiceParams } from 'rbh-merchant-core';
import { AUTH_REQUEST_ID_LIST } from './auth-constant';

class AuthServiceClass {
  private url = `${envConfig.hostname}`;
  postValidateEmail = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: this.url + 'v1/merchant/company-admin/validation/email',
      data: params.data,
      id: AUTH_REQUEST_ID_LIST.POST_VALIDATION_EMAIL
    });
  }

  checkMailIsFirstLogin = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: this.url + 'v1/merchant/company-admin/forgot-password/resend',
      data: params.data,
      id: AUTH_REQUEST_ID_LIST.IS_FIRST_LOGIN
    });
  }
}

export const AuthService = new AuthServiceClass();
